import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid, IconButton, makeStyles, Paper, Chip } from "@material-ui/core";
import CloseIcon from '@material-ui/icons/Close';

// 樣式定義
const useStyles = makeStyles((theme) => ({
    dialogTitle: {
        padding: theme.spacing(2),
        backgroundColor: "#f7f7f7", 
        borderBottom: '1px solid #ccc',
    },
    customTitleContent: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontWeight: "bold",
        width: '100%',
    },
    dialogContent: {
        padding: theme.spacing(3),
    },
    rowLabel: {
        backgroundColor: "#f7f7f7", 
        fontWeight: "bold",
        padding: theme.spacing(1.5),
        borderRight: "1px solid #eee",
        minWidth: 120, 
        textAlign: "left",
        display: 'flex',
        alignItems: 'center',
    },
    rowContent: {
        padding: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
    },
    tableGrid: {
        border: "1px solid #ccc",
    },
    emailChip: {
        margin: theme.spacing(0.5),
        borderColor: "#5597b4",
        color: "#5597b4",
        backgroundColor: "transparent",
        "& svg": {
            color: "#5597b4",
        },
    },
    cancelButton: {
        color: "#999",
        border: "1px solid #ccc",
        "&:hover": {
            backgroundColor: "#eee",
        },
    },
}));

function EventNotificationViewDialog({ open, onClose, eventId, getEventNotification }) {
    const classes = useStyles();
    const [eventData, setEventData] = useState({
        windFarmName: "海能",
        event_name: "",
        event_content: "",
        note: "",
        notification_date: "",
        notification_time: "",
        deadline_date: "",
        emails: [],
    });
    const [loading, setLoading] = useState(true);

    // 獲取事件資料
    useEffect(() => {
        if (open && eventId) {
            setLoading(true);
            getEventNotification(eventId)
                .then((response) => {
                    const data = response.data;
                    setEventData({
                        windFarmName: data.windcontract_name || "",
                        event_name: data.event_name || "",
                        event_content: data.event_content || "",
                        note: data.note || "",
                        notification_date: data.notification_date || "",
                        notification_time: data.notification_time || "",
                        deadline_date: data.deadline_date || "",
                        emails: data.emails || [],
                    });
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("Error fetching event:", error);
                    setLoading(false);
                });
        }
    }, [open, eventId, getEventNotification]);

    const CustomDialogTitle = (props) => {
        const { children, onClose } = props;
        return (
            <DialogTitle disableTypography className={classes.dialogTitle}>
                <div className={classes.customTitleContent}>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>{children}</Typography>
                    {onClose ? (
                        <IconButton aria-label="close" onClick={onClose} size="small">
                            <CloseIcon />
                        </IconButton>
                    ) : null}
                </div>
            </DialogTitle>
        );
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="md"
            fullWidth
            aria-labelledby="event-notification-view-dialog-title"
        >
            <CustomDialogTitle id="event-notification-view-dialog-title" onClose={onClose}>
                查看事件提醒
            </CustomDialogTitle>
            
            <DialogContent dividers className={classes.dialogContent}>
                {loading ? (
                    <Typography>載入中...</Typography>
                ) : (
                    <Paper variant="outlined" className={classes.tableGrid}>
                        {/* 風場名稱 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                風場名稱
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Typography>{eventData.windFarmName}</Typography>
                            </Grid>
                        </Grid>

                        {/* 事件標題 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                事件標題
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Typography>{eventData.event_name}</Typography>
                            </Grid>
                        </Grid>

                        {/* 事件內容 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                事件內容
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Typography style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{eventData.event_content}</Typography>
                            </Grid>
                        </Grid>

                        {/* 備註 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                備註
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Typography style={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{eventData.note}</Typography>
                            </Grid>
                        </Grid>

                        {/* 通知日期 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                通知日期
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                {/* <Typography>{eventData.notification_date}</Typography> */}
                                <Typography>{String(eventData.notification_date).split(/[ T]/)[0]}</Typography>
                            </Grid>
                        </Grid>

                        {/* 通知時間 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                通知時間
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Typography>{eventData.notification_time}</Typography>
                            </Grid>
                        </Grid>

                        {/* 截止日期 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                截止日期
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Typography>{String(eventData.deadline_date).split(/[ T]/)[0]}</Typography>
                                <Typography> ({String(eventData.deadline_date).split(/[ T]/)[1]})</Typography>
                            </Grid>
                        </Grid>

                        {/* 外部收件者 */}
                        <Grid container style={{ borderBottom: '1px solid #eee' }}>
                            <Grid item xs={3} className={classes.rowLabel}>
                                外部收件者
                            </Grid>
                            <Grid item xs={9} className={classes.rowContent}>
                                <Box display="flex" flexWrap="wrap">
                                    {eventData.emails.length > 0 ? (
                                        eventData.emails.map((email) => (
                                            <Chip
                                                key={email}
                                                label={email}
                                                variant="outlined"
                                                className={classes.emailChip}
                                            />
                                        ))
                                    ) : (
                                        <Typography>無收件者</Typography>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                )}
            </DialogContent>

            <DialogActions style={{ padding: '16px 24px' }}>
                <Button 
                    onClick={onClose} 
                    className={classes.cancelButton}
                    variant="outlined"
                >
                    關閉
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default EventNotificationViewDialog;